module.exports = __webpack_public_path__ + "static/4-9463180927ed3f46b3aaa909cdef428d.jpg";